import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { TitleBar, IconClose, IconStar, IconCheck, IconEdit, evenRowColor, IconLock } from '../../common/theme';
import { isObjectEmpty, toArray } from '../../../Utils';

const ContainerComp = ({pageState, parentState}) =>{
    const [studentData, setStudentData] = useState({});
    const [checkMarkData, setCheckMarkData] = useState({});
    const [hasAssignments, setHasAssignments] = useState(false);
    const [isPretestable, setIsPretestable] = useState(true);

    const componentData = {
        studentData, setStudentData,
        checkMarkData, setCheckMarkData,
        isPretestable, setIsPretestable,        
        parentRefresh: parentState.refreshCompState, setParentRefresh: parentState.setRefreshCompState,
        programList: parentState.programsSelected, setProgramList: parentState.setProgramsSelected,
        setProgramNamesList: parentState.setProgramNamesSelected
    };

    useEffect(() => {     
        if(studentData && studentData.programs){
            let checkMarks = {};
            studentData.programs.forEach(progRec=>{
                checkMarks[progRec.id] = {isCheckedPretest: progRec.hasPretest, isCheckedPosttest:progRec.hasPosttest, hasPretestLocked:false, hasPosttestLocked:false};
            });
            setCheckMarkData({...checkMarks });
        }
    },[studentData]); 

    useEffect(() => {     
        if(!parentState.refreshCompState) return;

        let student = componentData.studentData;
        if(isObjectEmpty(student))
            student = pageState.processedStudentAssignments.find(studRec=>studRec.StudentID === parentState.studentSelectedID);

        if(!student){
            setStudentData({});
            setHasAssignments(false);
            parentState.setRefreshCompState(false);
            return;
        }

        setStudentData({...student });

        // check if the "remove assignments button should be disabled"
        let programs = student.programs.filter(progRec => parentState.programsSelected.indexOf(progRec.id) > -1);
        let hasAssignment = (programs) ? programs.filter((progRec)=>progRec.hasAssignment === true).length > 0 : false;
        setHasAssignments(hasAssignment);            

        parentState.setRefreshCompState(false);
    });    

    useEffect(() => {     
        if(!pageState.resetInnerSaveState) return;
        let student = pageState.processedStudentAssignments.find(studRec=>studRec.StudentID === parentState.studentSelectedID);
        setStudentData({...student });
        pageState.setResetInnerSaveState(false);
    }); 

    return <div><ProgramModulesTableComp pageState={pageState} assignments={{hasAssignments}} componentData={componentData} parentState={parentState}/></div>;
};

const ProgramModulesTableComp = ({pageState, assignments, componentData, parentState}) => {    
    const {hasAssignments} = assignments;
    const [isDisabledTestSave, setIsDisabledTestSave] = useState(true);

    useEffect(() => {     
        let shouldDisabledTestSave = true;

        if(componentData && componentData.studentData && componentData.studentData.programs && !isObjectEmpty(componentData.checkMarkData)){
            componentData.studentData.programs.map(progRec=>{
                // TODO: Changing classes and clicking on a program to assign too fast can sometimes not give enough time to load the new class and will crash
                if(!componentData.checkMarkData[progRec.id]) { 
                    console.error('Error with componentData.checkMarkData!', progRec.id, {...componentData.checkMarkData});
                    return; 
                }                
                if(componentData.checkMarkData[progRec.id].isCheckedPretest && !progRec.hasPretest)
                    shouldDisabledTestSave = false;
                if(!componentData.checkMarkData[progRec.id].isCheckedPretest && progRec.hasPretest)
                    shouldDisabledTestSave = false;

                if(componentData.checkMarkData[progRec.id].isCheckedPosttest && !progRec.hasPosttest)
                    shouldDisabledTestSave = false;
                if(!componentData.checkMarkData[progRec.id].isCheckedPosttest && progRec.hasPosttest)
                    shouldDisabledTestSave = false;
            });
            setIsDisabledTestSave(shouldDisabledTestSave);
        }
    }); 

    const resetTests=()=>{
        let nextState = {};
        if(componentData && componentData.studentData && componentData.studentData.programs && !isObjectEmpty(componentData.checkMarkData)){
            componentData.studentData.programs.map(progRec=>{
                nextState[progRec.id] = {
                    isCheckedPretest: progRec.hasPretest, 
                    isCheckedPosttest: progRec.hasPosttest,
                    hasPretestLocked: false,
                    hasPosttestLocked: false
                };
            });
        }
        componentData.setCheckMarkData(nextState);
    };   

    const saveTests = () => {
        let pretestChanges = componentData.studentData.programs.reduce((acc,progRec)=>{
            if(componentData.checkMarkData[progRec.id].isCheckedPretest && !progRec.hasPretest)
                acc.push({test:'pretest',programID:progRec.id,type:'add'});
            if(!componentData.checkMarkData[progRec.id].isCheckedPretest && progRec.hasPretest)
                acc.push({test:'pretest',programID:progRec.id,type:'remove'});
            return acc;
        },[]);
        let posttestChanges = componentData.studentData.programs.reduce((acc,progRec)=>{
            if(componentData.checkMarkData[progRec.id].isCheckedPosttest && !progRec.hasPosttest)
                acc.push({test:'posttest',programID:progRec.id,type:'add'});
            if(!componentData.checkMarkData[progRec.id].isCheckedPosttest && progRec.hasPosttest)
                acc.push({test:'posttest',programID:progRec.id,type:'remove'});
            return acc;
        },[]);
        
        let allChanges = pretestChanges.concat(posttestChanges);
        allChanges = allChanges.reduce((acc,savRec)=>{
            if(savRec.type === 'add'){
                acc.push(savRec);
                return acc;
            }            
            if(!allChanges.find(e=>(e.programID === savRec.programID && e.type === 'add' )))
                acc.push(savRec);

            return acc;
        },[]);
       
        parentState.setRequestState({programs: allChanges, studID:componentData.studentData.StudentID, assign:'test'});
    };    

    const removeAssignments = (assign, type) => {
        let programsToRemove = componentData.studentData.programs.filter(progRec=>progRec.hasAssignment && parentState.programsSelected.find(progID=>progRec.id===progID)).map(progRec=>progRec.id);
        parentState.setRequestState({programs: programsToRemove, studID:componentData.studentData.StudentID, assign:'assignments'});
    };

    const selectAllPretest=(type)=>()=>{
        let nextState = {};
        
        Object.keys(componentData.checkMarkData).map(key => {
            if(key==='C4' || key==='C5' || key==='C6' ||
                key==='HLR2P' || key==='HLR3' || key==='HLR3P' || key==='HLR4' || key==='HLR4P' ||
                key==='LRP' || key==='LR1' || key==='LR2' || key==='LR3' ||
                key==='MMM' || key.startsWith('QUIZ') || key.startsWith('LESSON') || key.startsWith('COURSE'))
                nextState[key] = {isCheckedPretest: false, isCheckedPosttest: false, hasPretestLocked:false, hasPosttestLocked:false};
            else{
                let program = componentData.studentData.programs.filter(programRec=>programRec.id===key);
                let hasPretestLocked = program[0].hasPretest;                                    
                if(type==='add') nextState[key] = {isCheckedPretest: true, isCheckedPosttest: false, hasPretestLocked, hasPosttestLocked:false};
                if(type==='remove') nextState[key] = {isCheckedPretest: false, isCheckedPosttest: componentData.checkMarkData[key].isCheckedPosttest, hasPretestLocked:false, hasPosttestLocked:false};
            }
        });

        componentData.setCheckMarkData(nextState);
    };   

    const selectAllPosttest=(type)=>()=>{
        let nextState = {};
        
        Object.keys(componentData.checkMarkData).map(key => {
            if(key==='C4' || key==='C5' || key==='C6' ||
                key==='HLR2P' || key==='HLR3' || key==='HLR3P' || key==='HLR4' || key==='HLR4P' ||
                key==='LRP' || key==='LR1' || key==='LR2' || key==='LR3' ||
                key==='MMM' || key.startsWith('QUIZ') || key.startsWith('LESSON') || key.startsWith('COURSE'))
                nextState[key] = {isCheckedPretest: false, isCheckedPosttest: false, hasPretestLocked:false, hasPosttestLocked:false};
            else{
                let program= componentData.studentData.programs.filter(programRec=>programRec.id===key);   
                let hasPosttestLocked = program[0].hasPosttest;    
                if(type==='add') nextState[key] = {isCheckedPretest: false, isCheckedPosttest: true, hasPretestLocked:false, hasPosttestLocked};
                if(type==='remove') nextState[key] = {isCheckedPretest: componentData.checkMarkData[key].isCheckedPretest, isCheckedPosttest: false, hasPretestLocked:false, hasPosttestLocked:false};    
            }
        });

        componentData.setCheckMarkData(nextState);
    };
    
    const unselectAllAssignments = () => {
        let cloneData = JSON.parse(JSON.stringify(componentData.studentData));
        cloneData.programs = cloneData.programs.map(progRec=>{return{...progRec, isSelected:false};});
        componentData.setStudentData(cloneData);
        // componentData.setProgramList(cloneData.programs.reduce((acc, progRec)=> {
        //     (progRec.isSelected) && acc.push(progRec.ProgID);
        //     return acc;
        // },[]));
        componentData.setProgramList([]);
        componentData.setProgramNamesList([]);
        componentData.setParentRefresh(true);
    };

    return (
        <Container>
            <TitleBar>
                <Col  style={{textAlign: 'left'}} xs='5'>Programs</Col>
                <Col xs='2'>Pre-Test<br/>
                    {(parentState.programsSelected.length===0)?<>
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={selectAllPretest('add')}><IconCheck/></Button>&nbsp;
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={selectAllPretest('remove')}><IconClose/></Button>
                    </>:<>
                        <Button data-toggle={'Press to unlock tests by resetting assignment selections'} title={'Press to unlock tests by resetting assignment selections'} style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={unselectAllAssignments}><IconLock/></Button>
                    </>}
                </Col>
                <Col xs='2'>Post-Test<br/>
                    {(parentState.programsSelected.length===0)?<>
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={selectAllPosttest('add')}><IconCheck/></Button>&nbsp;
                        <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={selectAllPosttest('remove')}><IconClose/></Button>
                    </>:<>
                        <Button data-toggle={'Press to unlock tests by resetting assignment selections'} title={'Press to unlock tests by resetting assignment selections'} style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={unselectAllAssignments}><IconLock/></Button>
                    </>}
                </Col>
                <Col xs='3'>Assign Modules<br/>
                {(!isDisabledTestSave)&&<>
                        <Button data-toggle={'Press to unlock assignments by resetting test selections'} title={'Press to unlock assignments by resetting test selections'} style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'danger'} onClick={resetTests}><IconLock/></Button>
                </>}
                </Col>
            </TitleBar>            
            <StudentRow pageState={pageState} componentData={componentData} parentState={parentState} testsSelected={!isDisabledTestSave}/>
            <Row style={{marginTop:'10px'}}>                
                <Col xs='5'>
                    <Button disabled={isDisabledTestSave} variant={'success'} onClick={()=>saveTests()}>Save</Button>&nbsp;
                    {(!isDisabledTestSave)&&<Button variant={'danger'} onClick={resetTests}>Cancel</Button>}
                </Col>
                <Col xs='7'>
                {parentState.programsSelected.length!==0 && <Button className="pull-right" variant={'danger'} onClick={unselectAllAssignments} >Cancel</Button>}
                {hasAssignments &&
                    <span className="pull-right"><Button variant={'primary'} disabled={!hasAssignments} onClick={()=>removeAssignments('assignments','remove')} >Remove <IconEdit style={{color:'#ffffff', paddingLeft:'3px'}}/></Button>&nbsp;</span>
                }
                </Col>
            </Row>
            <br/>
        </Container>
    );
};

ProgramModulesTableComp.propTypes = {
    data: PropTypes.object
};

const StudentRow = ({pageState, componentData, parentState, testsSelected}) => {
    let {id, title, programs } = componentData.studentData;  

    return (
        <Row>
            <Col style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', border: '1px solid #cfcfcf'}}>
                {!programs && <>There are no assignments. Please click the red back button to continue.</>}
                {(programs) && programs.filter(e=>toArray(pageState.ownProgramsData).some(test=>test.NAME===e.id)).map((progRec, i) => 
                    <ProgramRow key={i} index={i} pageState={pageState} programData={progRec} componentData={componentData} hasTestsChecked={testsSelected} hasAssignmentSelected={(parentState.programsSelected.length>0)} />
                )}
            </Col>
        </Row>
    );
};

const ProgramRow = ({pageState, programData, componentData, index, hasTestsChecked, hasAssignmentSelected}) =>{
    const {title, id:ProgramID, hasPretest, hasPosttest, hasAssignment, isSelected, assignAuthor} = programData;
    const [isPretestable,setIsPretestable] = useState(true);
    // const selectedStyle = (isSelected) ? {backgroundColor:'lightblue'} : (index%2==0)?{background:evenRowColor}:{};
    const backgroundStyle = (isSelected) ? '#ADD8E6' : (index%2==0)?evenRowColor:'#FFFFFF';
    const backgroundStyleGrey = (isSelected) ? 'lightgrey' : (index%2==0)?evenRowColor:'#FFFFFF';
    // const backgroundStyleGreyX = (isSelected) ? 'grey' : '#ff9f9f';      
    const backgroundStyleGreyX = '#ff4f4f';      
    const selectedStyle = {backgroundColor:backgroundStyle};

    useEffect(()=>{
        if(ProgramID==='C4' || ProgramID==='C5' || ProgramID==='C6' ||
        ProgramID==='HLR2P' || ProgramID==='HLR3' || ProgramID==='HLR3P' || ProgramID==='HLR4' || ProgramID==='HLR4P' ||
        ProgramID==='LRP' || ProgramID==='LR1' || ProgramID==='LR2' || ProgramID==='LR3' ||
        ProgramID==='MMM' || ProgramID.startsWith('QUIZ') || ProgramID.startsWith('LESSON') || ProgramID.startsWith('COURSE'))
            setIsPretestable(false);    
    });

    const isPretestDisabled =(programID)=> {
        let isDisabled = false;
        if((componentData && componentData.checkMarkData && componentData.checkMarkData[programID]))
            isDisabled = componentData.checkMarkData[programID].hasPretestLocked; 
        if (!isDisabled) isDisabled = false;
        let hasChangedPosttest = hasChangedOn('Posttest',programID);                               
        return hasAssignmentSelected || isDisabled || hasChangedPosttest;
    };
    const isPosttestDisabled =(programID)=> {
        let isDisabled = false;
        if((componentData && componentData.checkMarkData && componentData.checkMarkData[programID]))
            isDisabled = componentData.checkMarkData[programID].hasPosttestLocked;
        if (!isDisabled) isDisabled = false;
        let hasChangedPretest = hasChangedOn('Pretest',programID);            
        return hasAssignmentSelected || isDisabled || hasChangedPretest;
    };

    const showCheckedAssignment=()=>{
        if(!isSelected)
            return false;
        return isSelected;
    };

    const showCheckedPretest=(programID)=>{

        if(!(componentData && componentData.checkMarkData && componentData.checkMarkData[programID]))
            return false;

        return componentData.checkMarkData[programID].isCheckedPretest;
    };
    const showCheckedPosttest=(programID)=>{
        if(!(componentData && componentData.checkMarkData && componentData.checkMarkData[programID]))
            return false;

        return componentData.checkMarkData[programID].isCheckedPosttest;
    };

    const onChangeHandlerPretest=(programID)=>(event)=>{
        componentData.setCheckMarkData({...componentData.checkMarkData, [programID]:{isCheckedPretest:event.target.checked, isCheckedPosttest: false}});
    };    

    const onChangeHandlerPosttest=(programID)=>(event)=>{
        componentData.setCheckMarkData({...componentData.checkMarkData, [programID]:{isCheckedPretest:false, isCheckedPosttest: event.target.checked}});
    };    
    
    const toggleSelected = (progID) => {
        if(hasTestsChecked) return;
        let cloneData = JSON.parse(JSON.stringify(componentData.studentData));
        let currentProgram = cloneData.programs.find(progRec=>progRec.id===progID);
        currentProgram.isSelected = !currentProgram.isSelected;
        componentData.setStudentData(cloneData);

        let progData = cloneData.programs.reduce((acc, progRec)=> {
            if(progRec.isSelected){
                acc.push({id:progRec.id,title:progRec.title});
            }
            return acc;
        },[]);
        componentData.setProgramList(progData.map(e=>e.id));
        componentData.setProgramNamesList(progData.map(e=>e.title));

        componentData.setParentRefresh(true);
    };

    const hasChanged = (type, programID) =>{
        const pretestNowOff = (hasPretest && !showCheckedPretest(programID));
        const posttestNowOff = (hasPosttest && !showCheckedPosttest(programID));

        if (isSelected && !pageState.hasMouseInsideModulesPanel) return false;

        if (type==='Pretest' && pretestNowOff) return true;
        if (type==='Posttest' && posttestNowOff) return true;       
        
        if (type==='Pretest' && (hasPretest && showCheckedAssignment())) return true;
        if (type==='Posttest' && (hasPosttest && showCheckedAssignment())) return true;         
        
        if (type==='Assignment' && hasAssignment && (showCheckedPretest(programID) || showCheckedPosttest(programID))) return true;

        return false;
    };

    const hasChangedOn = (type, programID) =>{
        const isPretestChecked = showCheckedPretest(programID);
        const isPosttestChecked = showCheckedPosttest(programID);

        const pretestNowOff = (hasPretest && !isPretestChecked);
        const posttestNowOff = (hasPosttest && !isPosttestChecked);
       
        if (type==='Pretest' && !isPosttestChecked) return false;
        if (type==='Posttest' && !isPretestChecked) return false;
        if (type==='Pretest' && pretestNowOff) return true;
        if (type==='Posttest' && posttestNowOff) return true;       
        
        return false;
    };

    return(

        <Row style={selectedStyle}>
            <Col xs='5'>{title}</Col>
            {(isPretestable)?
            <>
                <Col style={{textAlign: 'center', backgroundColor:backgroundStyleGrey}} xs='2'>{hasChanged('Pretest',ProgramID)?<IconClose style={{color: backgroundStyleGreyX}} />:<IconClose style={{color: backgroundStyleGrey}} />}<input type="checkbox" onChange={(e)=>onChangeHandlerPretest(ProgramID)(e)} checked={showCheckedPretest(ProgramID)} disabled={isPretestDisabled(ProgramID)}/></Col>
                <Col style={{textAlign: 'center', backgroundColor:backgroundStyleGrey}} xs='2'>{hasChanged('Posttest',ProgramID)?<IconClose style={{color: backgroundStyleGreyX}} />:<IconClose style={{color: backgroundStyleGrey}} />}<input type="checkbox" onChange={(e)=>onChangeHandlerPosttest(ProgramID)(e)} checked={showCheckedPosttest(ProgramID)} disabled={isPosttestDisabled(ProgramID)}/></Col>
            </>:
            <>
                <Col style={{textAlign: 'center', fontSize:'1em', backgroundColor:backgroundStyleGrey}} xs='2'><IconClose style={{color: backgroundStyleGrey}} />N/A</Col>
                <Col style={{textAlign: 'center', fontSize:'1em', backgroundColor:backgroundStyleGrey}} xs='2'><IconClose style={{color: backgroundStyleGrey}} />N/A</Col>
                {/* <Col style={{textAlign: 'center'}} xs='2'><IconClose style={{color: '#EfEfEf'}} /></Col>
                <Col style={{textAlign: 'center'}} xs='2'><IconClose style={{color: '#EfEfEf'}} /></Col> */}
            </>}

            <Col style={{textAlign: 'center'}} xs='3'>{hasChanged('Assignment',ProgramID)?<IconClose style={{color: '#ff4f4f'}} />:<IconClose style={{color: backgroundStyle}} />} 
                <span onClick={()=>toggleSelected(ProgramID)} xs='6' style={{cursor: 'pointer'}} disabled={hasTestsChecked}>
                {(hasAssignment)&&<IconEdit style={{fontWeight:'bold', color:((hasTestsChecked)?'grey':(assignAuthor==='pretest')?'red':'green')}}/>} 
                </span>
                {(!hasAssignment)&&<input type="checkbox" onChange={(e)=>toggleSelected(ProgramID)} checked={showCheckedAssignment()} disabled={hasTestsChecked}/>}
            </Col>
        </Row>        
    );
};

export default ContainerComp;